<template>
  <gj-modal v-bind="$attrs"
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    :footer="false"
    size="normal"
    :loading="importHandleLoading"
    :loading-text="importHandleLoadingText">
    <template #header>
      <span>导入业务报告</span>
    </template>
    <template #content>
      <el-form ref="form"
        :inline="true"
        class="demo-form-inline"
        :model="form">
        <el-form-item>
          <gj-market-select :clearable="false"
            v-model="form.marketId"
            @input="marketChange($event)"
            placeholder="请选择店铺"
            width="120px">
          </gj-market-select>
        </el-form-item>
        <el-form-item prop="date">
          <gj-date-picker v-model="form.date"
            width="200px"
            :clearable="false"
            @change="pickerOptions"
            placeholder="请选择日期">
          </gj-date-picker>
        </el-form-item>
      </el-form>
      <div>
        <gj-upload :disabled="btnImport"
          container-type="shipmentProduct"
          text="导入业务报告"
          @uploadAfter="uploadAfter"
          style="margin-bottom: 12px;">
        </gj-upload>
      </div>
      <gj-import-alert :rules="[
          '下载位置：Reports→Business Reports→Detail Page Sales and Traffic by Child Item根据商品→子商品详情页面上的销售量与访问量',
          '导出时，请选择该报表的所有项，报告中的内容不可更改，不可删除',
          '重复导入将自动覆盖原始数据',
          'ASIN、父ASIN维度的数据将根据MSKU维度的数据自动汇总'
        ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, uploadMixin } from "@/minxins";
import { importBusinessReport } from "@/api/statistics";
import { convertToDate } from "@/utils/date.util";
export default {
  name: "app-listing-analysis-performence-modal",
  mixins: [modalMixIn, uploadMixin],
  props:{
    groupType:null
  },
  data() {
    return {
      btnImport: true,
      form: {
        date: null,
        marketId: null
      }
    };
  },
  methods: {
    destroy() {
      this.$gjModal.$gjDestroy();
    },
    pickerOptions(val) {
      this.form.marketId !== null && val !== null
        ? (this.btnImport = false)
        : (this.btnImport = true);
    },
    marketChange(marketId) {
      marketId !== null && this.form.date !== null
        ? (this.btnImport = false)
        : (this.btnImport = true);
    },
    uploadAfter(attId, data, uploadCb) {
      this.importHandleLoading = true;
      importBusinessReport({
        attachmentId: attId,
        marketId: this.form.marketId,
        trafficDate: convertToDate(this.form.date),
        groupType:this.groupType
      })
        .then(res => {
          this.$gjImportHandle(res, uploadCb);
        }).catch(() => {
            uploadCb('error')
          })
        .complete(() => (this.importHandleLoading = false));
    }
  }
};
</script>

<style scoped>
.upload-btn {
  margin: 5px 0 15px;
}
.m-tb-20 {
  margin: 20px 0px 20px 0px;
}
.m-t-10 {
  margin-top: 10px;
}
div .el-select {
  width: 175px !important;
}
</style>
